// :: User Store
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

// :: State
const state = {
  checklist: [
    {
      title: "Global",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-global"
    },
    {
      title: "Sucursal Toluca",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-toluca"
    },
    {
      title: "Sucursal Aguascalientes",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-aguascalientes"
    },
    {
      title: "Sucursal Coatzacoalcos",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-coatzacoalcos"
    },
    {
      title: "Sucursal Cuatitlán",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-cuatitlan"
    },
    {
      title: "Sucursal Cuernavaca",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-cuernavaca"
    },
    {
      title: "Sucursal Guadalajara",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-guadalajara"
    },
    {
      title: "Sucursal Tizayuca",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-tizayuca"
    },
    {
      title: "Sucursal Mérida",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-merida"
    },
    {
      title: "Sucursal Monterrey",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-monterrey"
    },
    {
      title: "Sucursal Puebla",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-puebla"
    },
    {
      title: "Sucursal Salitre",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-salitre"
    },
    {
      title: "Sucursal San Luis Potosí",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-potosi"
    },
    {
      title: "Sucursal Silao",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-silao"
    },
    {
      title: "Sucursal Veracruz",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-veracruz"
    },
    {
      title: "Sucursal San José Chiapa",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-chiapa"
    },
    {
      title: "Sucursal Corporativo",
      value: false,
      section: "dynamicBoard",
      id: "dynamic-board-sucursal-corporativo"
    },
    {
      title: "Número Total de Pedidos (Dashboard)",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-dashboard"
    },
    {
      title: 'Checklist de "entrega"',
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-delivery"
    },
    {
      title: 'Checklist de "mantenimiento"',
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-maintenance"
    },
    {
      title: 'Checklist de "recolección"',
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-recollection"
    },
    {
      title: 'Checklist de "reubicación"',
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-relocation"
    },
    {
      title: 'Checklist de "rentado servicio"',
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-rentedservice"
    },
    {
      title: "Sucursal Toluca",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-toluca"
    },
    {
      title: "Sucursal Aguascalientes",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-aguascalientes"
    },
    {
      title: "Sucursal Coatzacoalcos",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-coatzacoalcos"
    },
    {
      title: "Sucursal Cuatitlán",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-cuatitlan"
    },
    {
      title: "Sucursal Cuernavaca",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-cuernavaca"
    },
    {
      title: "Sucursal Guadalajara",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-guadalajara"
    },
    {
      title: "Sucursal Tizayuca",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-tizayuca"
    },
    {
      title: "Sucursal Mérida",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-merida"
    },
    {
      title: "Sucursal Monterrey",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-monterrey"
    },
    {
      title: "Sucursal Puebla",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-puebla"
    },
    {
      title: "Sucursal Salitre",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-salitre"
    },
    {
      title: "Sucursal San Luis Potosí",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-potosi"
    },
    {
      title: "Sucursal Silao",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-silao"
    },
    {
      title: "Sucursal Veracruz",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-veracruz"
    },
    {
      title: "Sucursal San José Chiapa",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-chiapa"
    },
    {
      title: "Sucursal Corporativo",
      value: false,
      section: "damage",
      subSection: "read",
      id: "damage-read-sucursal-corporativo"
    },
    {
      title: 'Checklist de "entrega"',
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-delivery"
    },
    {
      title: 'Checklist de "mantenimiento"',
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-maintenance"
    },
    {
      title: 'Checklist de "recolección"',
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-recollection"
    },
    {
      title: 'Checklist de "reubicación"',
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-relocation"
    },
    {
      title: 'Checklist de "rentado servicio"',
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-rentedservice"
    },
    {
      title: "Sucursal Toluca",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-toluca"
    },
    {
      title: "Sucursal Aguascalientes",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-aguascalientes"
    },
    {
      title: "Sucursal Coatzacoalcos",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-coatzacoalcos"
    },
    {
      title: "Sucursal Cuatitlán",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-cuatitlan"
    },
    {
      title: "Sucursal Cuernavaca",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-cuernavaca"
    },
    {
      title: "Sucursal Guadalajara",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-guadalajara"
    },
    {
      title: "Sucursal Tizayuca",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-tizayuca"
    },
    {
      title: "Sucursal Mérida",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-merida"
    },
    {
      title: "Sucursal Monterrey",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-monterrey"
    },
    {
      title: "Sucursal Puebla",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-puebla"
    },
    {
      title: "Sucursal Salitre",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-salitre"
    },
    {
      title: "Sucursal San Luis Potosí",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-potosi"
    },
    {
      title: "Sucursal Silao",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-silao"
    },
    {
      title: "Sucursal Veracruz",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-veracruz"
    },
    {
      title: "Sucursal San José Chiapa",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-chiapa"
    },
    {
      title: "Sucursal Corporativo",
      value: false,
      section: "damage",
      subSection: "edit",
      id: "damage-write-sucursal-corporativo"
    },
    {
      title: "Operación Global",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-global"
    },
    {
      title: "Sucursal Toluca",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-toluca"
    },
    {
      title: "Sucursal Aguascalientes",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-aguascalientes"
    },
    {
      title: "Sucursal Coatzacoalcos",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-coatzacoalcos"
    },
    {
      title: "Sucursal Cuatitlán",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-cuatitlan"
    },
    {
      title: "Sucursal Cuernavaca",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-cuernavaca"
    },
    {
      title: "Sucursal Guadalajara",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-guadalajara"
    },
    {
      title: "Sucursal Tizayuca",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-tizayuca"
    },
    {
      title: "Sucursal Mérida",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-merida"
    },
    {
      title: "Sucursal Monterrey",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-monterrey"
    },
    {
      title: "Sucursal Puebla",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-puebla"
    },
    {
      title: "Sucursal Salitre",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-salitre"
    },
    {
      title: "Sucursal San Luis Potosí",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-potosi"
    },
    {
      title: "Sucursal Silao",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-silao"
    },
    {
      title: "Sucursal Veracruz",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-veracruz"
    },
    {
      title: "Sucursal San José Chiapa",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-chiapa"
    },
    {
      title: "Sucursal Corporativo",
      value: false,
      section: "indicators",
      subSection: "sucursal",
      id: "indicators-sucursal-corporativo"
    },
    {
      title: "Ocupación",
      value: false,
      section: "indicators",
      subSection: "weekly-meeting",
      id: "indicators-weekly-meeting-occupation"
    },
    {
      title: "Detalle de Ocupación",
      value: false,
      section: "indicators",
      subSection: "weekly-meeting",
      id: "indicators-weekly-meeting-occupation-detail"
    },
    {
      title: "Top de Ocupación/Mod",
      value: false,
      section: "indicators",
      subSection: "weekly-meeting",
      id: "indicators-weekly-meeting-occupation-top"
    },
    {
      title: "Porcentaje Equipos Servicio",
      value: false,
      section: "indicators",
      subSection: "weekly-meeting",
      id: "indicators-weekly-meeting-service-equipment-percentage"
    },
    {
      title: "Servicios en Taller",
      value: false,
      section: "indicators",
      subSection: "weekly-meeting",
      id: "indicators-weekly-meeting-workshop-services"
    },
    {
      title: "Clientes Morosos",
      value: false,
      section: "indicators",
      subSection: "weekly-meeting",
      id: "indicators-weekly-meeting-delinquent-clients"
    },
    {
      title: "Servicios en Obra",
      value: false,
      section: "indicators",
      subSection: "weekly-meeting",
      id: "indicators-weekly-meeting-on-site-services"
    },
    {
      title: "Órdenes de Trabajo",
      value: false,
      section: "indicators",
      subSection: "weekly-meeting",
      id: "indicators-weekly-meeting-work-orders"
    },
    {
      title: "Facturación y Cobranza",
      value: false,
      section: "indicators",
      subSection: "weekly-meeting",
      id: "indicators-weekly-meeting-billing-collection"
    },
    {
      title: "Head Count",
      value: false,
      section: "indicators",
      subSection: "weekly-meeting",
      id: "indicators-weekly-meeting-head-count"
    },
    {
      title: "Fuerzas de Ventas",
      value: false,
      section: "indicators",
      subSection: "weekly-meeting",
      id: "indicators-weekly-meeting-sales-forces"
    },
    {
      title: "Ocupación",
      value: false,
      section: "indicators",
      subSection: "general",
      id: "indicators-general-ocupation"
    },
    {
      title: "Detalle de Ocupación",
      value: false,
      section: "indicators",
      subSection: "general",
      id: "indicators-general-ocupation-detail"
    },
    {
      title: "Facturación y Cobranza",
      value: false,
      section: "indicators",
      subSection: "general",
      id: "indicators-general-billing-collection"
    },
    {
      title: "Detalle Rentados",
      value: false,
      section: "indicators",
      subSection: "general",
      id: "indicators-general-rent-detail"
    },
    {
      title: "Ocupación por Modelos",
      value: false,
      section: "indicators",
      subSection: "general",
      id: "indicators-general-occupation-by-models"
    },
    {
      title: "Head Count",
      value: false,
      section: "indicators",
      subSection: "general",
      id: "indicators-general-head-count"
    },
    {
      title: "Porcentaje Equipos Servicio",
      value: false,
      section: "indicators",
      subSection: "operations",
      id: "indicators-operations-service-equipment-percentage"
    },
    {
      title: "Top equipos en servicio ",
      value: false,
      section: "indicators",
      subSection: "operations",
      id: "indicators-operations-top-teams-in-service"
    },
    {
      title: "Servicios en obra",
      value: false,
      section: "indicators",
      subSection: "operations",
      id: "indicators-operations-on-site-services"
    },
    {
      title: "Servicios en taller",
      value: false,
      section: "indicators",
      subSection: "operations",
      id: "indicators-operations-workshop-services"
    },
    {
      title: "Total servicios abiertos",
      value: false,
      section: "indicators",
      subSection: "operations",
      id: "indicators-operations-total-open-services"
    },
    {
      title: "Tiempo promedio servico",
      value: false,
      section: "indicators",
      subSection: "operations",
      id: "indicators-operations-average-service-time"
    },
    {
      title: "Registrar y Administrar Usuarios",
      value: false,
      section: "createUsers",
      id: "user-creation"
    },
    {
      title: "Checklist realizados",
      value: false,
      section: "reports",
      id: "reports-checklist-make"
    },
    {
      title: "Incidencias reportadas",
      value: false,
      section: "reports",
      id: "reports-incidence-reported"
    },
    {
      title: "Porcentaje de checklist completados",
      value: false,
      section: "reports",
      id: "reports-average-completed-checklist"
    },
    {
      title: "Reporte de checklist por usuarios",
      value: false,
      section: "reports",
      id: "reports-checklist-reported-by-user"
    },
    {
      title: "Top de incidencias",
      value: false,
      section: "reports",
      id: "reports-top-incidence"
    },
    {
      title: "Reporte de uso por usuario",
      value: false,
      section: "reports",
      id: "reports-use-by-user"
    },
    {
      title: "Reporte de movimientos por usuario",
      value: false,
      section: "reports",
      id: "reports-actions-by-user"
    },
    {
      title: "Ver KPIs",
      value: false,
      section: "carousel",
      id: "show-kpi"
    },
    {
      title: "Editar KPIs",
      value: false,
      section: "carousel",
      id: "add-kpi"
    },
    {
      title: "Admin KPIs",
      value: false,
      section: "carousel",
      id: "admin-kpi"
    }
  ]
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
